export default class CaptureMethodModel {
  id!: number;

  descricao!: string;
}
